import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import echarts from "echarts";
import elementui from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/table.scss";
import "./assets/style/global.css";
import "./assets/style/global.scss";
import "./assets/style/mixis.scss";
import "./assets/style/element-variables.scss"; //改变主题颜色
import Moment from "moment";
import Vuex from "vuex";
import "./resgisterServiceWorker";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
// import jquery from "jquery"
import constant from "./utils/constants.js";
import utils from "./utils/util.js";
import "./assets/font/font.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import "./assets/reset.css";
import "./assets/font/iconfont.css";
import "./assets/rem";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import gojs from 'gojs'
import clipboard from "clipboard";
import { loginController } from "@/api/activityController";
import {
  getSellerInfo,
} from "@/api/sellerController";
import { authCheck } from "@/api/activityController";
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { checkPermisson } from "@/common/permission"
import common from './common/decrypt'
import decryptBatch from './common/batchDecrypt'
import commonOptimization from './common/commonOptimization'
import { uploadPointData } from "@/api/home.js";

Vue.prototype.clipboard = clipboard;
//图片拖动排序
import VueDND from "awe-dnd";
import DYTip from "@/components/new/dy-tip.vue";
import DYButton from "@/components/new/dy-button.vue";
import prizeShowTpyeBtn from "@/components/prizeShowTpyeBtn.vue";
Vue.use(VueDND);
Vue.use(Viewer);
Vue.use(VueVideoPlayer);

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

import DYsubTab from "@/components/new/dy-subTab.vue";
import DYTitle from "@/components/new/dy-title.vue";
import DYForm from "@/components/Form/index.vue";
import DYTable from "@/components/Table/index.vue";
import DYDialog from "@/components/new/dy-dialog.vue";
import exposeProductsPreview from "@/views/integralCenter/activityPage/exposeProductsPreview.vue";
Vue.component("dy-form", DYForm);
Vue.component("dy-table", DYTable);
Vue.component("dy-subTab", DYsubTab);
Vue.component("dy-title", DYTitle);
Vue.component("dy-tip", DYTip);
Vue.component("dy-button", DYButton);
Vue.component("show-button", prizeShowTpyeBtn);
Vue.component("dy-dialog", DYDialog);
Vue.component("exposeProductsPreview", exposeProductsPreview);

/***************引入gojs为原型函数*************************************/
Vue.prototype.$go = gojs
Vue.prototype.$make = gojs.GraphObject.make

// 全局京豆总数判断三个必填项 row.quantityTotal京豆总数   row.price京豆单个奖励  row.prizeCount填写的京豆总份数额
// Vue.prototype.$jingdouTotal = (row) => {
//   if (row.quantityTotal && row.prizeCount && Number(row.prizeCount) * Number(row.price) > row.quantityTotal) {
//     return "";
//   } else {
//     return row.prizeCount;
//   }
// }
Vue.prototype.$jingdouTotal = commonOptimization.jingdouTotal
Vue.prototype.$getDate = commonOptimization.getDate
Vue.prototype.$getYMDHMS = commonOptimization.getYMDHMS
Vue.prototype.$getActDate = commonOptimization.getActDate
Vue.prototype.$commonUrl = commonOptimization.commonUrl
Vue.prototype.$toChinesNum = commonOptimization.toChinesNum
//el-input挂载
import onlyNumber from "@/directive/el-input"; //添加此行=>自定义全局指令

Vue.use(onlyNumber); //添加此行=>使用该全局指令

Vue.use(Vuex);

Vue.use(Moment); 
Vue.use(elementui, { size: "small", zIndex: 3000 });
Vue.use(echarts);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(constant);
Vue.use(utils);

// Vue.prototype.jq = jquery
Vue.prototype.$globalCdn = "https://cdn-image.yucrm.cn/images/dyAssets";
// 双击解密
Vue.prototype.$decrypt = common;

// 批量解密
Vue.prototype.$decryptBatch = decryptBatch;

Vue.prototype.moment = Moment;

Vue.prototype.$echarts = echarts;

Vue.prototype.$myVue = Vue;

// 全局CDN地址
Vue.prototype.$globalCdn = 'https://cdn-image.yucrm.cn/images/dyAssets';

Vue.config.productionTip = false;

Vue.prototype.bus = new Vue();

// 配置当前玩法的默认分享海报
// id：玩法id  返回值为图片地址
Vue.prototype.getDefaultSharePic = function(id){
  switch (id) {
    case 1: // 签到
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_641dcd9356ce43768b45e127fba176b3.png"
    case 2: // 每日限时抢
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c877055d2d5e450a90be5101f38d30a4.png"
    case 3: // 关注店铺有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_4d33db69ca024903843d99a9a79e2a53.png"
    case 4: // 邀请开卡有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_d179bed0c9f94747a1935b0323856796.png"
    case 5: // 邀请关注有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_f1b051fe8b6c43d787bec7510bf70762.png"
    case 6: // 完善信息有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_878e1739c2214440b312ea8a235446a4.png"
    case 8: // 大转盘抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_c1f527acd10947528b7ee35398fdb062.png"
    case 16: // 下单有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_e2457cd5a00e4059b8e4c38f9c59cfce.png"
    case 17: // 首购有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_60af7364b2c94ae79cb0aaee9e4dc20f.png"
    case 18: // 复购有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_18256c6db9ad49eeaff4875b46cd5738.png"
    case 19: // 下单抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_d70f9a4540eb4ed6b6d6c0c500f3b970.png"
    case 20: // 评价有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5596ffd7934a4357bee8a162a97b57d3.png"
    case 21: // 裂变神券
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5cf953d0208e4a9eb8e7217ddabc8cc6.png"
    case 22: // 天降红包雨
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_baed0f4b975b42e2bafceb8b85df4fef.png"
    case 23: // 欢乐娃娃机
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_794a6b6194d34dbea0f4b7c77d197f2c.png"
    case 24: // 大家来找茬
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_b9ecef75382a4dcdb217eba4daf8429f.png"
    case 27: // 预售有礼
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_7340c47bbeda451ea8eb39de2644510e.png"
    case 28: // 预售抽奖
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_9e504eae36d148a294359f00875fd540.png"
    case 31: // 超级裂变券
      return "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_57a1234181024b3b850f6596b32c67e3.png"
    case 34: // 加购有礼
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_5108d958fef14a688d435033dbf29a90.png'
    case 35: // 积分锁权
      return 'https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/624092_lockAuthShare.jpg'
    default:
      break;
  }
}

Vue.directive('preventReClick', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})
let maidian = (value)=> {
    if (window._hmt) {
      window._hmt.push(['_trackEvent', '按钮点击', 'click', `${value.from}-${value.name}`]);
    }  
}
// 按钮埋点
Vue.directive('zoom', {
  inserted  (el, binding ) {
    el.onclick = ()=>maidian(binding.value)
  },

  update(el,binding){
    let old = binding.oldValue.from
    let newV = binding.value.from
    if (old !=newV) {
      // console.log(el);
      // el.removeEventListener('click', ()=>maidian(binding.oldValue),false)
      el.onclick  = false
      el.onclick = ()=>maidian(binding.value)
    }

  }
})
// 标签埋点
Vue.directive('labelZoom', {
  inserted (el, binding) {
    el.addEventListener('click', () => {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', '标签选择', 'active', `${binding.value.name}`]);
      }  
    })
  }
})

// 定时器标识
let timer = null;
let timeEnter = null;
let times = 0;

// 埋点计时器
Vue.prototype.setIntervalFun = async function(
  firstClassify,
  secondClassify,
  name,
  id,
  route
) {
  if (!id) return;
  timer = setTimeout(() => {
    times = times + 1;
    // 页面停留超过1小时，停止埋点
    if (times >= 3600) {
      console.log(times);
      this.clearBuriedPoint();
      console.log("停止埋点");
      return;
    }
    // var routes = this.$route.path + this.$route.hash.substring(1);
    this.buriedPointTimes(firstClassify, secondClassify, name, id, route);
    console.log("埋点成功", name, firstClassify, secondClassify);
  }, 2000);
};
// 清除埋点
Vue.prototype.clearBuriedPoint = function() {
  clearTimeout(timer);
};
let route;
// 页面埋点
Vue.prototype.buriedPoint = async function(
  action,
  firstClassify,
  secondClassify,
  name,
  type
) {
  let flage = false;
  if (!flage) {
    this.clearBuriedPoint();
    clearTimeout(timeEnter);
    flage = true;
  }
  if (flage) {
    var route = this.$route.path + this.$route.hash.substring(1);
    setTimeout(async () => {
      times = 0;
      console.log(route, "this.$route");
      let params = {
        platform: "dyhd",
        venderId: "",
        shopTitle: "",
        source: 0, //来源 0:pc端 1:移动端
        action: action, //类型 1进入页面 2点击按钮 3授权进入 4操作
        url: route, // 路径
        name: name, //"页面/按钮名称（1、2类型时要有）",
        sign: encryptMI(), //JSE加密
        firstClassify: firstClassify, // 一级分类
        secondClassify: secondClassify, // 二级分类
        type:type
      };
      // 当前店铺信息
      let { data: userInfo } = await getSellerInfo();
      // 当前店铺信息
      params.shopId = userInfo.shopId;
      params.shopTitle = userInfo.shopName;
      params.venderId = userInfo.shopId;
      sessionStorage.setItem("operatePrefix", userInfo.operatePrefix);
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      // 调用埋点
      let res = await uploadPointData(params);
      if (res.code) {
        this.buriedPointTimes(firstClassify, secondClassify, name, res.data, route);
      }
    }, 500);
  }
};

const getParamvenderId = async () => {
  const sellerPlatform = JSON.parse(sessionStorage.getItem("userInfo") || '{}')
  let paramvenderId = ''

  if (sellerPlatform && sellerPlatform.shopId) {
    paramvenderId = sellerPlatform.shopId
  } else {
    const { data } = await getSellerInfo()
    sessionStorage.setItem("userInfo", JSON.stringify(data))
    paramvenderId = data.shopId
  }

  return paramvenderId
}
let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
// 轮询埋点
Vue.prototype.buriedPointTimes = async function(
  firstClassify,
  secondClassify,
  name,
  id,
  route
) {
  const paramvenderId = await getParamvenderId()
  let params = {
    platform: "dyhd",
    venderId: paramvenderId,
    shopTitle: "",
    source: 0, //来源 0:pc端 1:移动端
    action: 5, //类型 1进入页面 2点击按钮 3授权进入 4操作
    url: route, // 路径
    name: name, //"页面/按钮名称（1、2类型时要有）",
    sign: encryptMI(), //JSE加密
    firstClassify: firstClassify, // 一级分类
    secondClassify: secondClassify, // 二级分类
    requestId: id, // 请求id
  };
  params.shopId = userInfo.shopId;
  params.shopTitle = userInfo.shopName;
  // 调用埋点
  let res = await uploadPointData(params);
  // 轮询-埋点
  this.clearBuriedPoint();
  this.setIntervalFun(firstClassify, secondClassify, name, id, route);
};

// JSEncrypt加密
const encryptMI = function(origin = Date.now()) {
  // 公钥
  const key =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDa+vHCmfKZxVdMBbp69Stu4u11BlOqfEDXK8HqZJ8dKHArYd+78wMzvpQZcWFtdix8MYaTLQERIaxjRoLrGYvYiONi+dKaZ/SSAI8boATYb1Wimz/ocUIGGj2SSZwQ6l5xzOu7orKVdrzUMpqETbuxRwAeMe1ZP/YQ20aXmmGBgwIDAQAB";
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(key);
  return encrypt.encrypt(origin + "");
};
// 监听该元素外的点击
Vue.directive('clickOutside', {
  inserted(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function (event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
        binding.value(event);
      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unInserted(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener("click", el.clickOutsideEvent);
  },
})
//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src =  hm.src = "https://hm.baidu.com/hm.js?68e65e77b10e09e3bff6192dcf88de08";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

router.beforeEach((to, from, next) => {

  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview',"/"+ to.fullPath])
    }
  }
  const permission = checkPermisson(to.path)
  if(permission) {
    if (to.name == "smartPoster?activityType=25" || to.name == "scratchers?activityType=26" || to.name == 'memberCard?activityType=32' || to.name == "freeTrial?activityType=33") {
      authCheck({ subtype: to.query.activityType }).then(res => {
        if (res.data.isNeedAuth) {
              window.open(res.data.authUrl, "_self");
          next();
        } else {
          next();
        }
      });
    } else {
      next();
    }
  } else {
    next("/integralCenter/home?permission=false");
  }

  //Note--测试不跳转  
  // next();
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
